<template>
    <div>
       
    </div>
</template>

<script>
export default {
    name:'documentosmasivos',
    props:['item','action'],
    data:()=> {
        return {
            items:[],
            preitem: {},
        }
    },
    mounted(){
    this.initPreItem();
    },
    watch:{
    'action.i': function () {
        
            if(this.action.i){   
                for( let i = 0; i<this.item.length; i++){ 
                    this.completeItem(i)
                }
             }          
        },
    'action.reset': function () {
            if(this.action.reset){
                this.items = []
            }   
         }    
    },
    methods:{
        initPreItem(){
          this.preitem = {
               baseAfectacionIgv:'',
               cantidad:'',
               codigoProducto:'',
               codigoTributo:'',
               descripcion:'',
               idEmisor:'',
               idFacturaItem:'',
               identificador:'',
               montoAfectacionIgv:'',
               montoTotalImpuestosItem:'',
               porcentajeImpuesto:'',
               precioVentaUnitario:'',
               tipoAfectacionIgv:'',
               tipoPrecioVentaUnitario:'',
               unidadMedidaCantidad:'',
               valorUnitario:'',
               valorVenta:'',
               idProducto:'-'
            };
        },
        completeItem(i){
            
            this.preitem.baseAfectacionIgv = parseFloat(this.item[i].baseAfectacionIgv),
            this.preitem.cantidad = parseFloat(this.item[i].cantidad),
            this.preitem.codigoProducto = this.item[i].codigoProducto
            if(this.item[i].tipoAfectacionIgv == 10){
                this.preitem.codigoTributo = "1000"   
            }else if(this.item[i].tipoAfectacionIgv == 20){
                this.preitem.codigoTributo = "9997"  
            }else if(this.item[i].tipoAfectacionIgv == 30){
                this.preitem.codigoTributo = "9998"
            }        
            this.preitem.descripcion = this.item[i].descripcion,
            this.preitem.idEmisor = this.item[i].idEmisor,
            this.preitem.idFacturaItem = this.item[i].idFacturaItem,
            this.preitem.identificador = this.item[i].identificador,
            this.preitem.montoAfectacionIgv = parseFloat(this.item[i].montoAfectacionIgv),
            this.preitem.montoTotalImpuestosItem = parseFloat(this.item[i].montoTotalImpuestosItem),
            this.preitem.porcentajeImpuesto = parseFloat(this.item[i].porcentajeImpuesto),
            this.preitem.precioVentaUnitario = parseFloat(this.item[i].precioVentaUnitario),
            this.preitem.tipoAfectacionIgv = this.item[i].tipoAfectacionIgv,
            this.preitem.tipoPrecioVentaUnitario = this.item[i].tipoPrecioVentaUnitario,
            this.preitem.unidadMedidaCantidad = this.item[i].unidadMedidaCantidad,
            this.preitem.valorUnitario = parseFloat(this.item[i].valorUnitario),
            this.preitem.valorVenta = parseFloat(this.item[i].valorVenta),
            
            this.items.unshift(this.preitem)
            this.initPreItem()
            this.getItems(this.items)
        },
        getItems: function (data) {
            this.$emit("totalitems", data);
        }
    }
}
</script>